module.exports = __webpack_public_path__ + "img/nycc-footer.aafbc30b.png";